import React from "react";
import { RiseLoader } from "react-spinners";

const Loader = ({ text, isLoading }) => {
  if (!isLoading) return null;

  return (
    <div
      className="d-flex align-items-center justify-content-center flex-column"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(255, 255, 255, 0.6)",
        zIndex: 1050,
        gap: "2rem",
      }}
    >
      <RiseLoader color="#fde428" />
      {text ? <p className="h5 m-0">{text}</p> : null}
    </div>
  );
};

export default Loader;
